/* eslint-disable no-console */
import { availableAtScreenSize } from './utils';
import ContactDealer from './contact-dealer';
import { onPageExit } from '../../utils/activity-utils';
import SitePopup from '../site-popup';

const modalId = 'site-abandon-modal';

const isAvailable = () => {
  const { location } = window;
  // Remove -modal from id before adding to params
  const shortId = modalId.substring(0, modalId.indexOf('-modal'));
  const url = `/api/IsSiteAbandonPopupNeeded?id=${shortId}&currentPage=${location}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.text().then(resolve);
        } else {
          response.text().then(reject);
        }
      })
      .catch(console.error);
  });
};

const initModal = (modalHtml) => {
  // Append html to the end of the DOM
  const body = document.querySelector('body');
  const div = document.createElement('div');
  div.innerHTML = modalHtml.trim();
  body.appendChild(div.firstChild);
  const modal = new SitePopup({
    id: modalId,
  });
  modal.open();
  // Init dealer contact js, if .site-abandon-dealer-contact-modal
  // Pass in instance of modal
  const isContactDealer = document.querySelector('.site-abandon-dealer-contact-modal');
  if (isContactDealer) {
    ContactDealer(modal);
  }
};

const siteAbandonPopup = () => {
  const { sitePopupsEnabled } = window;
  const popupCriteria = availableAtScreenSize() && sitePopupsEnabled;
  if (!popupCriteria) {
    return;
  }
  onPageExit(() => {
    isAvailable()
      .then((data) => {
        if (data !== '~error~') {
          initModal(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  });
};

export default siteAbandonPopup;
/* eslint-enable no-console */
